import { useDispatch, useSelector } from 'react-redux';

import { getBookingWidgetRoomData } from 'features/roomsSlice';

const useGetRoomData = () => {
    const dispatch = useDispatch();

    const checkInDate = useSelector(
        (state) => state.miniBookingWidget?.data?.checkin
    );
    const checkOutDate = useSelector(
        (state) => state.miniBookingWidget?.data?.checkout
    );

    const roomsUrl = useSelector(
        (state) => state.miniBookingWidget?.data?.bigPlugin?.allRoomsUrl
    );

    const userProvidedData = useSelector((state) => state.user);
    // TODO: DON'T KNOW IF ALL THESE ARE NECESSARY, PROBABLY NOT
    // I THINK THAT 'sortBy' is SUFFICIENT
    const getRoomData = ({ currency, language, sortBy = '' } = {}) => {
        dispatch(
            getBookingWidgetRoomData({
                roomsUrl,
                adults: userProvidedData.adults,
                checkin:
                    userProvidedData.checkInDay?.date ||
                    checkInDate?.split('/').reverse().join('-'),
                checkout:
                    userProvidedData.checkOutDay?.date ||
                    checkOutDate?.split('/').reverse().join('-'),
                children: userProvidedData.children,
                currency: currency || userProvidedData.currency,
                localeLanguage: language || userProvidedData.language,
                rooms: userProvidedData.numberOfRooms,
                sortBy: sortBy || userProvidedData.sortBy,
            })
        );
    };
    return getRoomData;
};

export default useGetRoomData;
